import { ITableElement } from "shared/components/interfaces/table.interface";
import { formatCurrency } from "shared/utils";
import { IExportedPackage } from "../types";
import { MenuActionsExportedPackages } from "../components/MenuActionsExportedPackages";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Tooltip } from "@mui/material";

interface ColumnsExportedPackagesProps {
  onViewDetail: (packageData: IExportedPackage) => void;
  onRevertExport: (packageData: IExportedPackage) => void;
  onDownloadZip: (packageData: IExportedPackage) => void;
  onLoadPaymentInfo: (packageData: IExportedPackage) => void;
  onDownloadDraftResolution: (packageData: IExportedPackage) => void;
}

export const columnsExportedPackages = ({
  onViewDetail,
  onRevertExport,
  onDownloadZip,
  onLoadPaymentInfo,
  onDownloadDraftResolution,
}: ColumnsExportedPackagesProps): ITableElement<IExportedPackage>[] => {
  return [
    {
      field: "viewDetail",
      headerName: "",
      minWidth: 30,
      renderCell(params: IExportedPackage) {
        return (
          <Tooltip title="Ver detalle" placement="top" arrow>
            <AddCircleIcon
              onClick={() => onViewDetail(params)}
              data-testid={`view-detail-icon-${params.id}`}
              style={{ cursor: "pointer" }}
            />
          </Tooltip>
        );
      },
    },
    {
      field: "paymentConsecutive",
      headerName: "Consecutivo de pago",
      sortable: "payment_consecutive",
      minWidth: 180,
      renderCell(params: IExportedPackage) {
        return <>{params.paymentConsecutive ?? ""}</>;
      },
    },
    {
      field: "nit",
      headerName: "NIT prestador de salud",
      sortable: "nit",
      minWidth: 180,
      renderCell(params: IExportedPackage) {
        return <>{params.nit ?? ""}</>;
      },
    },
    {
      field: "healthProvider",
      headerName: "Prestador de salud",
      sortable: "health_provider",
      minWidth: 280,
      renderCell(params: IExportedPackage) {
        return <>{params.healthProvider ?? ""}</>;
      },
    },
    {
      field: "invoicesCount",
      headerName: "Cantidad de facturas exportadas",
      sortable: "invoices_count",
      minWidth: 220,
      renderCell(params: IExportedPackage) {
        return <>{params.invoicesCount ?? 0}</>;
      },
    },
    {
      field: "totalExportValue",
      headerName: "Total exporte de pago",
      sortable: "total_export_value",
      minWidth: 180,
      renderCell(params: IExportedPackage) {
        return <>{formatCurrency(params.totalExportValue ?? 0)}</>;
      },
    },
    {
      field: "exportStatus",
      headerName: "Estado de exporte de pago",
      sortable: "export_status",
      minWidth: 200,
      renderCell(params: IExportedPackage) {
        return <>{params.exportStatus ?? ""}</>;
      },
    },
    {
      field: "actions",
      headerName: "",
      minWidth: 0,
      renderCell(params: IExportedPackage) {
        return (
          <MenuActionsExportedPackages
            packageData={params}
            onViewDetail={onViewDetail}
            onRevertExport={onRevertExport}
            onDownloadZip={onDownloadZip}
            onLoadPaymentInfo={onLoadPaymentInfo}
            onDownloadDraftResolution={onDownloadDraftResolution}
          />
        );
      },
    },
  ];
};
